import { makeSelectors } from '@utils/css';

const crossFadeDurationMs = 200;
const modifiers = makeSelectors({
  isPlaying: "_uqxine3el5"
});
const audioButton = "_uqxa1drwjx5";
const icon = "_uqxilooxgt";
const asyncProgressCircle = "_uqxa1h8lvah";

export { asyncProgressCircle, audioButton, crossFadeDurationMs, icon, modifiers };
import "./audio-button.style.linaria.module.css";
//# sourceMappingURL=audio-button.style.js.map
